import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { finalize, map, Observable, tap } from 'rxjs';
import { loginData, tokenRefreshData } from '../../interfaces/services-data';
import { environment } from '../../../../environments/environment';
import { LoaderService } from '../loader/loader.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private http: HttpClient, private readonly loaderService:LoaderService, private cookieService: CookieService) { }

  /* Login del usuario */
  userLogin(data: loginData): Observable<any> {
    return this.http.post(`${environment.apiBase}v1/user/login`, data)
      .pipe(
        map((response: any) => {
          this.setCookiesLegacy(response.data[0].legacySession);
          return response;
        })
    )
  }

  /* Refrescar tokens del usuario */
  refreshToken(data: tokenRefreshData): Observable<any> {
    return  this.http.post(`${environment.apiBase}v1/user/refresh-token`, data);
  }

  // POST /v1/user/google/front/callback

  getGoogleLoginUrl(): Observable<any> {
    return this.http.get(`${environment.apiBase}v1/user/google/login`);
  }

  /* Login con google */
  googleLogin(data: any): Observable<any> {
    return  this.http.post(`${environment.apiBase}v1/user/google/front/callback`, data);
  }

  /**
   * registerUser
   */
  registerUser(data: any): Observable<any> {
    this.loaderService.show();
    return this.http.post(`${environment.apiBase}v1/user/register-sale`, data).pipe(
      map((response: any) => {
        this.setCookiesLegacy(response.data.legacySession);
        return response;
      }),
      finalize(() => this.loaderService.hide())
    )
  }

  private setCookiesLegacy(cookieValue:any) {
    this.cookieService.set('laravel_session', cookieValue.value, cookieValue.maxAge, cookieValue.path, cookieValue.domain, false, 'None');

  }
}
